import * as Yup from 'yup'

export const AirspaceSelectCityFormSchema = Yup.object().shape({
  city: Yup.string().required('City is required'),
})
